import { all, takeLatest, put, fork, call } from 'redux-saga/effects';
import actions from './actions';
import * as blanksDropDownServices from '@iso/services/reading/fillInBlanksDropDown';
// import { ReadingMapping } from '../../../mapping/reading/ReadingMapping';

//#region CRUD
export function* getBlanksDropDown() {
	yield takeLatest(actions.GET_DROP_DOWN, function* ({ payload }) {
		const { model } = payload;
		try {
			var response = yield call(blanksDropDownServices.getAPIBlanksDropDown, model);
			if (response.data.success === true) {
				var data = response.data.data.data;
				var totalItems = response.data.data.total;
				yield put({
					type: actions.GET_DROP_DOWN_SUCCESS,
					payload: { data, totalItems },
				});
			}
		} catch (e) {
			yield put({
				type: actions.READING_LOADING_FALSE,
			});
		}
	});
}

export function* getBlanksDropDownDetail() {
	yield takeLatest(actions.GET_DROP_DOWN_DETAIL, function* ({ payload }) {
		const { id } = payload;
		try {
			var response = yield call(blanksDropDownServices.getAPIBlanksDropDownDetail, id);
			if (response.data.success === true) {
				var data = response.data.data;
				var totalItems = response.data.data.total;
				yield put({
					type: actions.GET_DROP_DOWN_DETAIL_SUCCESS,
					payload: { data, totalItems },
				});
			}
		} catch (e) {
			yield put({
				type: actions.READING_LOADING_FALSE,
			});
		}
	});
}

export function* createBlanksDropDown({ payload, cbSuccess, cbError }) {
	try {
		const res = yield call(blanksDropDownServices.postAPIBlanksDropDown, payload);
		if (res.status === 200) {
			yield cbSuccess();
		}
		else if (res?.data?.message === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
			yield cbError('Trùng thứ tự');
		}
	} catch (error) {
		yield cbError();
	}
}

// export function* createQuesReadAloud() {
// 	yield takeLatest(actions.CREATE_NEW_DROP_DOWN, function* ({ payload, cbSuccess, cbError }) {
// 		const { model } = payload;
// 		try {
// 			var response = yield call(blanksDropDownServices.createQuesReadAloud, model);
// 			if (response.data.success === true) {
// 				yield cbSuccess();
// 			}
// 		} catch (e) {
// 			if (e.response && e.response.data) yield cbError(e.response.data.ErrorMessage);
// 			else yield cbError();
// 		}
// 	});
// }

// export function* updateReadAloudDetail() {
// 	yield takeLatest(actions.UPDATE_DROP_DOWN_DETAIL, function* ({ payload, cbSuccess, cbError }) {
// 		const { model } = payload;
// 		try {
// 			var response = yield call(blanksDropDownServices.updateReadAloudDetail, model);
// 			if (response.data.success === true) {
// 				yield cbSuccess();
// 			}
// 		} catch (e) {
// 			if (e.response && e.response.data) yield cbError(e.response.data.ErrorMessage);
// 			else yield cbError();
// 		}
// 	});
// }

// export function* deleteReadAloud() {
// 	yield takeLatest(actions.DELETE_DROP_DOWN, function* ({ payload, cbSuccess, cbError }) {
// 		const { id } = payload;
// 		try {
// 			var response = yield call(blanksDropDownServices.deleteReadAloud, id);
// 			if (response.data.success === true) {
// 				yield cbSuccess();
// 			}
// 		} catch (e) {
// 			if (e.response && e.response.data) yield cbError(e.response.data.ErrorMessage);
// 			else yield cbError();
// 		}
// 	});
// }

// export default function* rootSaga() {
// 	yield all([fork(getBlanksDropDown), fork(getReadAloudDetail), fork(createQuesReadAloud), fork(updateReadAloudDetail), fork(deleteReadAloud)]);
// }

export default function* rootSaga() {
	yield all([fork(getBlanksDropDown), fork(getBlanksDropDownDetail)]);
	yield all([takeLatest(actions.CREATE_NEW_DROP_DOWN, createBlanksDropDown)]);
}
